import React from 'react';

import {Container, StoreInfos} from './styles';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

interface Props {
  first?: boolean;
  horizontal?: boolean;
  asPadding?: boolean;
  border?: boolean;
}
export function StoreShimmer({
  horizontal,
  asPadding,
  border = true,
}: Props) {
  const theme = useTheme();
  return (
    <Container
      style={{
        shadowOpacity: border ? 0.04 : 0,
        elevation: border ? 1 : 0,
        backgroundColor: border ? undefined : 'transparent',
        marginRight: horizontal ? RFValue(12) : 0,
        marginHorizontal: asPadding ? 24 : 0,
        borderWidth: border ? 1 : 0,
        padding: border ? RFValue(12) : 0
      }}>
      <ShimmerPlaceHolder
        style={{
          width: RFValue(48),
          height: RFValue(48),
          borderRadius: RFValue(12),
        }}
        shimmerColors={theme.colors.shimmer_placeholder}
      />

      <StoreInfos>
        <ShimmerPlaceHolder
          style={{
            width: RFValue(70),
            height: RFValue(10),
            marginBottom: RFValue(6),
          }}
          shimmerColors={theme.colors.shimmer_placeholder}
        />
        <ShimmerPlaceHolder
          style={{width: RFValue(110), height: RFValue(12)}}
          shimmerColors={theme.colors.shimmer_placeholder}
        />
      </StoreInfos>
    </Container>
  );
}
